import { initGoogleAnalytics } from './utils/analytics.js';
import { getTrackingSkipReason, shouldLoadTrackers } from './utils/tracking-gate.js';

function scheduleWhenIdle(callback, timeout = 5000) {
	if (window.requestIdleCallback) {
		requestIdleCallback(callback, { timeout });
		return;
	}
	setTimeout(callback, 2000);
}

function initClarity() {
	(function (c, l, a, r, i, t, y) {
		c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
		t = l.createElement(r);
		t.async = 1;
		t.defer = 1;
		t.src = 'https://www.clarity.ms/tag/' + i;
		y = l.getElementsByTagName(r)[0];
		y.parentNode.insertBefore(t, y);
	})(window, document, 'clarity', 'script', 'n98jsuapp1');
}

function scheduleTrackers() {
	const skipReason = getTrackingSkipReason();
	if (skipReason) {
		console.info(`[ocontis] analytics skipped (${skipReason})`);
		return;
	}

	const run = () => {
		if (!shouldLoadTrackers()) return;

		initGoogleAnalytics();
		initClarity();
	};

	if (document.readyState === 'complete') {
		scheduleWhenIdle(run);
		return;
	}

	window.addEventListener('load', () => scheduleWhenIdle(run), { once: true });
}

scheduleTrackers();
